import * as React from "react";
import { WidgetContextInterface } from "..";

export function createWidgetComponent(
  component: React.FunctionComponent<WidgetContextInterface>
) {
  return React.memo(component);
}
